var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Language Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-LFM-flow-\\u2013-Rewe-case",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1b.-Login-\\u2013-LFM-\\u2013-Rewe-\\u2013-mvp",
    transform: "translate(-339.000000, -89.000000)",
    fill: "#6B6E85",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Language",
    transform: "translate(316.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1680213,6.00048964 C42.7031435,7.22513718 43,8.57778072 43,10 C43,15.525 38.52,20 32.995,20 C27.47,20 23,15.525 23,10 C23,4.475 27.47,0 32.995,0 C36.2684709,0 39.1751085,1.57088879 41.0004901,4.00032335 L38.2779002,3.99997886 C37.5018195,3.31728121 36.5918626,2.78302905 35.59,2.44 C36.19,3.55 36.645,4.75 36.97,6 L36.97,6 Z M34.91,14 L31.09,14 C31.52,15.43 32.17,16.765 33,17.965 C33.83,16.765 34.48,15.43 34.91,14 L34.91,14 Z M29.025,14 L26.075,14 C27.035,15.655 28.565,16.935 30.405,17.565 C29.805,16.45 29.35,15.25 29.025,14 L29.025,14 Z M39.925,14 L36.975,14 C36.65,15.25 36.195,16.445 35.595,17.56 C37.43,16.93 38.96,15.655 39.925,14 L39.925,14 Z M28.635,8 L25.26,8 C25.095,8.64 25,9.31 25,10 C25,10.69 25.095,11.36 25.26,12 L25.26,12 L28.64,12 C28.555,11.345 28.5,10.68 28.5,10 C28.5,9.32 28.555,8.655 28.635,8 L28.635,8 Z M35.34,8 L30.66,8 C30.565,8.655 30.5,9.32 30.5,10 C30.5,10.68 30.565,11.345 30.66,12 L30.66,12 L35.34,12 C35.435,11.345 35.5,10.68 35.5,10 C35.5,9.32 35.435,8.655 35.34,8 L35.34,8 Z M40.735,8 L37.36,8 C37.445,8.655 37.5,9.32 37.5,10 C37.5,10.68 37.44,11.345 37.36,12 L37.36,12 L40.735,12 C40.905,11.36 41,10.69 41,10 C41,9.31 40.9,8.64 40.735,8 L40.735,8 Z M33,2.035 C32.165,3.235 31.515,4.57 31.09,6 L31.09,6 L34.91,6 C34.485,4.57 33.835,3.235 33,2.035 Z M30.405,2.435 C28.565,3.065 27.035,4.345 26.075,6 L26.075,6 L29.025,6 C29.35,4.75 29.805,3.55 30.405,2.435 Z",
    id: "px-language"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxLanguage);
export default __webpack_public_path__ + "static/media/px-language.1ee29b42450beee6aa032c38173abf0e.svg";
export { ForwardRef as ReactComponent };